import Components from '@bootstrap/components'
import Resources from '@bootstrap/resources'
import Mixins from '@bootstrap/mixins'
import Translations from '@back/js/bootstrap/helpers/translations'
import Filters from '@back/js/bootstrap/filters'
import store from '@store/index'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Window
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.moment = require('moment-timezone');
window._ = require('lodash');
window.uuid = require('uuidv4');
window.Vue = Vue


// Language
window.i18n = new VueI18n({
	locale: 'fr',
	messages : {
		fr: store.state.i18n.fr,
		en: store.state.i18n.en,
	} 
});
